<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-default">
    </base-header>
    <b-container fluid class="mt--7">
      <b-row>
        <b-col lg="6" md="12" sm="12">
          <b-card>
            <b-card-header class="border-0">
              <h3 class="mb-0">Registrar noticias</h3>
            </b-card-header>
            <b-row class="form-group">
              <b-col md="10">
                <input v-model="news.title" class="form-control" placeholder="Titulo">
              </b-col>
            </b-row>
            <b-row class="form-group">
              <b-col md="10">
                <input v-model="news.url" class="form-control" placeholder="Url">
              </b-col>
            </b-row>
            <b-row class="form-group">
              <b-col md="10">
                <b-form-file @change="setImage"/>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
        <b-col lg="6" md="12" sm="12">
          <b-card>

            <b-row class="form-group">
              <b-col md="10">
                <ckeditor v-model="news.body"></ckeditor>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="">
                <b-button variant="primary" @click="createNews">GUARDAR INFORMACION</b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
        <b-col cols="12">
          <b-card class="table-responsive">
            <b-card-header class="border-0">
              <h3 class="mb-0">Listado noticias</h3>
            </b-card-header>
            <b-table hover small bordered :items="arrayNews" :fields="columns">
            </b-table>
            <b-pagination
              ref="paginator"
              @change="paginate"
              class="justify-content-end"
              :value="pagination.page"
              :total-rows="rows"
              :per-page="pagination.limit"
            ></b-pagination>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import {get, post} from "@/util/axiosRequest";
import uploadFile from "@/util/uploadFile";
export default {
  name: "News",
  data: () => ({
    news: {
      title: null,
      url: null,
      body: null,
      file: null
    },
    arrayNews: [],
    columns: [
      {key: "title", label:"Titulo", sortable: true},
      {key: "subtitle", label:"Texto", sortable: true},
      {key: "url", label:"url", sortable: true},
    ],
    rows: 0,
    pagination: {
      page: 1,
      limit: 20
    }
  }),
  mounted() {
    this.getNews()
  },
  methods: {
    async getNews(){
      const {data} = await get(`news?page=${this.pagination.page}&limit=${this.pagination.limit}`, null, true)
      this.arrayNews = data.data
      this.rows = data.count;
    },
    async createNews(){
      await uploadFile.upload(
        "news",
        this.news
      );
      this.clearForm()
      this.getNews()
    },
    setImage(e){
      this.news.file = e.target.files[0];
    },
    async paginate(page) {
      this.pagination.page = page;
      this.getNews();
    },
    clearForm(){
      this.news = {
        title: null,
        url: null,
        body: null,
        file: null
      }
    }
  }
}
</script>

<style scoped>

</style>
